import Loading from './Loading';

export { default as RobotLoading } from './RobotLoading';

export default Loading;
